/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{ConstraintTypes as t}from"./ConstraintTypes.js";import{InteractionType as i}from"./InteractionType.js";import{TiltMode as o}from"./TiltMode.js";class r{constructor(r=t.ALL,n=i.NONE,e=0,s=null,a=null,c=o.TUMBLE){this.selection=r,this.interactionType=n,this.interactionFactor=e,this.interactionStartCamera=s,this.interactionDirection=a,this.tiltMode=c}}export{r as ConstraintOptions};
